import RingHand from '../../src/legacy/RingHand.tsx';
export default RingHand;
